import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=2a4bda09&scoped=true&"
import script from "./Tree.vue?vue&type=script&lang=ts&"
export * from "./Tree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4bda09",
  null
  
)

export default component.exports